import React, { useCallback, useState } from 'react';
import {
  Grid,
  IconButton,
  SwipeableDrawer,
  List,
  Theme,
} from '@material-ui/core';
import {
  makeStyles,
  createStyles,
} from '@material-ui/styles';
import {
  Menu as MenuIcon,
} from '@material-ui/icons';
import clsx from 'clsx';
import Link from '../link/Link';
import logoDefault from '../../assets/img/ph/logo-text-blue.svg';
import PagesMainBarDrawerLink from './PagesMainBarDrawerLink';
import { Button } from '../';
import { Links } from '../../utility/links';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    display: 'flex',
    alignItems: 'stretch',
    paddingRight: '48px',
  },
  icon: {
    color: palette.icons.default,
    '&:hover': {
      color: palette.publicNavBar.hover
    },
  },
  button: {
    '&:focus': {
      outline: 'none',
    },
  },
  logoLink: {
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    width: '120px',
    height: '40px',
  },
  grow: {
    flexGrow: 1,
  },
  drawerPaper: {
    backgroundColor: palette.publicNavBar.background,
    color: palette.publicNavBar.color,
  },
  list: {
    width: '250px',
    height: '100%',
    padding: '32px 0 20px 0',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Montserrat',
  },
  drawerButtonItem: {
    padding: '8px',
  },
  drawerButton: {
    textTransform: 'none',
    fontWeight: 600,
  },
  primaryHover: {
    '&:hover': {
      backgroundColor: palette.buttonAction.background,
    },
  },
  link: {
    color: 'inherit',
    '&:hover': {
      textDecoration: 'none',
    },
  },
}), { name: 'PagesMainBarContentSm' });

const PagesMainBarContentSm = () => {
  const classes = useStyles();

  const [drawerOpened, setDrawer] = useState(false);
  const openDrawer = useCallback(() => setDrawer(true), [setDrawer]);
  const closeDrawer = useCallback(() => setDrawer(false), [setDrawer]);

  return (
    <>
      <Grid container className={classes.root}>
        <IconButton
          // edge="start"
          color="inherit"
          aria-label="open drawer"
          className={classes.button}
          onClick={openDrawer}
        >
          <MenuIcon className={classes.icon} />
        </IconButton>
        <Grid item className={classes.grow} />
        <Link
          className={classes.logoLink}
          to="/"
        >
          <img
            className={classes.logo}
            src={logoDefault}
            alt="pitchhub logo"
          />
        </Link>
        <Grid item className={classes.grow} />
      </Grid>
      <SwipeableDrawer
        open={drawerOpened}
        onClose={closeDrawer}
        onOpen={openDrawer}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <List
          className={classes.list}
          role="presentation"
          onClick={closeDrawer}
          onKeyDown={closeDrawer}
        >
          <PagesMainBarDrawerLink to="/pages/pricing">
            Pricing
          </PagesMainBarDrawerLink>
          <div className={classes.grow} />
          <Link to={Links.support} defaultAction target="_blank" className={classes.link}>
            <PagesMainBarDrawerLink>
              Support
            </PagesMainBarDrawerLink>
          </Link>
          <Link to={Links.blog} defaultAction target="_blank" className={classes.link}>
            <PagesMainBarDrawerLink>
              Blog
            </PagesMainBarDrawerLink>
          </Link>
          <PagesMainBarDrawerLink
            className={classes.drawerButtonItem}
            to="/pages/login"
            disableGutters
          >
            <Button
              className={classes.drawerButton}
              fullWidth
              variant="outlined"
              color="primary"
              overlay={false}
            >
              Log In
            </Button>
          </PagesMainBarDrawerLink>
          <PagesMainBarDrawerLink
            className={classes.drawerButtonItem}
            to="/pages/register"
            disableGutters
          >
            <Button
              className={clsx(classes.drawerButton, classes.primaryHover)}
              fullWidth
              variant="contained"
              color="primary"
            >
              Try for free!
            </Button>
          </PagesMainBarDrawerLink>
        </List>
      </SwipeableDrawer>
    </>
  );
};

export default PagesMainBarContentSm;
